export const LOGIN_ROUTE = '/login'
export const DUPLICATES_ROUTE = '/duplicates'
export const IMPORTANT_ROUTE = '/important'
export const IMPORTANT_UP_ROUTE = '/importantUP'
export const NEWS_ROUTE = '/news/'
export const NEWS_WITH_DATE_ROUTE = '/news/:date'
export const FILTERS_ROUTE = '/filters'




export const CATEGORIES_ROUTE = '/categories'

export const HOMEPAGE_ROUTE = '/'
